'use strict';

import angular from 'angular';
import {
  UtilService
} from './util.service';

export default angular.module('logServerApp.util', [])
  .factory('Util', UtilService)
  .name;



// WEBPACK FOOTER //
// ./client/components/util/util.module.js